import { useEffect, useState, useRef } from "react";

import Preloader from "../../components/preloader/preloader";
import PrimarySearchAppBar from "../../components/navBar/navBar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { set } from "date-fns";
import useCurrency from "../../hooks/useCurrency";


const CheckOut = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [gotTicketsFromLocoalStorage, setGotTicketsFromLocoalStorage] = useState(false);
  const [isTicketsData, setIsTicketsData] = useState(false);
  const [boxPlan, setBoxPlan] = useState(false);
  const [tickets, setTickets] = useState(null);
  const [choosenTickets, setChoosenTickets] = useState([]); //State variable for storing chosen tickets
  const [seats, setSeats] = useState(null);
  const [totalTicketQty, setTotalTicketQty] = useState(0); //State variable for storing total tickets qty
  const [totalSeatQty, setTotalSeatQty] = useState(0)
  const [totalQty, setTotalQty] = useState(0)
  const [totalTicketAmount, setTotalTicketAmount] = useState(0); //State variable for storing total ticket amount
  const [totalSeatAmount, setTotalSeatAmount] = useState(0) 
  const [totalAmount, setTotalAmount] = useState(0)
  const sideBarRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const {convert} = useCurrency();



  

  useEffect(() => {

    const amount = 12000;

    console.log(convert(amount))




    const eventName = localStorage.eventName;
    const eventVenue = localStorage.eventVenue;
    const eventDate = localStorage.selectedDateOfTheEvent;
    const eventTime = localStorage.selectedTimeOfTheEvent;
    const evdt_Id = parseInt(localStorage.evdt_id);
    setSelectedEvent([eventName, eventVenue, eventDate, eventTime, evdt_Id]);
    setGotTicketsFromLocoalStorage(true)

    const queryString = location.search; // Get the query string
    const urlParams = new URLSearchParams(queryString);

    // Get individual parameters
      const evdtId = urlParams.get("evdt_id");
      const seats_ = urlParams.get("seats");

    // Decode and parse the seats parameter
      const decodedSeats = decodeURIComponent(seats_);
      
      if(seats_ !== null){
        const parsedSeats = JSON.parse(decodedSeats);
        console.log({parsedSeats}, {evdtId});



        const sum = parsedSeats.reduce((acc, {adultCount})=>{
          console.log(adultCount)
          return acc + adultCount
        },0)

       

        setTotalSeatQty(sum)
        console.log({parsedSeats})
        setSeats(parsedSeats);
      }
  }, []);

  // fetch data for event that have Box plan seating/ Free seating
  
  useEffect(() => {

    console.log({selectedEvent})
    if (gotTicketsFromLocoalStorage) {
      const url = `${process.env.REACT_APP_DEV_BASE_URL}/event/${selectedEvent[4]}/tickets`;

      const fetchData = async () => {
        try {
          const response = await fetch(url);
          const json = await response.json();
          // console.log(json.data.tickets[0]);

          // setTickets(json.data.tickets.filter(ticket => ticket.box_plan === false));
          setTickets(json.data.tickets);
          if(json.data.tickets.length > 0){
            setIsTicketsData(true);
          }
        } catch (error) {
          console.log("error", error);
        }
      };
      fetchData();
    }
  }, [selectedEvent]);

  //Update each boxPlan seat amount
  useEffect(() => {
    if (seats === null || tickets === null) return;
    const seatsWithAmount = seats.map(seat => {
      const ticket = tickets.find(ticket => seat.seatCategoryId === ticket.et_id);
      if (ticket) {
        return { ...seat, amount: seat.adultCount * ticket.price };
      }
      return seat; // Return the original seat if no matching ticket is found
    });
  

      
    setSeats(seatsWithAmount);
   
  }, [tickets]);


  useEffect(() => {
    if (seats === null) return;
    const totalSeatAmount = seats.reduce((acc, seat) => acc + seat.amount, 0);

    setTotalSeatAmount(totalSeatAmount);
  }, [seats]);

  // Function to add tickets
  function addTickets(ticket_Category, ticket_Price, et_id, available) {

    console.log(ticket_Category, ticket_Price, et_id, available)  
    // Check if the ticket category already exists in the chosenTickets array
    const categoryExist = choosenTickets.find(
      (ticket) => ticket.category === ticket_Category
    );

    let newChoosenTickets;
    // If the ticket category does not exist, add a new ticket to the array
  
   
    if (!categoryExist) {

      let quantity = 1;

      newChoosenTickets = [
        ...choosenTickets,
        {
          category: ticket_Category,
          price: ticket_Price,
          quantity,
          et_id: et_id,
          amount: quantity * ticket_Price,
        },
      ];

      // console.log("Ticket added:", ticket_Category);
    } else {
      let quantity = 1;
      // If the ticket category exists, increase the quantity of that ticket
     if(categoryExist.quantity >= available){
        // alert("No more tickets available")
        return  
     }else{
      newChoosenTickets = choosenTickets.map((ticket) =>
        ticket.category === ticket_Category
          ? { ...ticket, quantity: ticket.quantity + 1, amount: (ticket.quantity + 1) * ticket.price}
          : ticket
      );
     }
       
      quantity = categoryExist.quantity + 1;
      console.log(quantity);
    }

    // Calculate the total quantity of all tickets
    const newTotalTicketQty = newChoosenTickets.reduce(
      (acc, ticket) => acc + ticket.quantity,
      0
    );

    const newTotalTicketAmount = newChoosenTickets.reduce(
      (acc, ticket) => acc + ticket.quantity * ticket.price, 0
    )

    // Update the chosenTickets and totalTicketQty states
    setChoosenTickets(newChoosenTickets);
    setTotalTicketQty(newTotalTicketQty);
    setTotalTicketAmount(newTotalTicketAmount);
    // console.log(choosenTickets);
  }

  // Function to remove tickets
  function removeTicket(ticket_Category) {
    // Decrease the quantity of the specified ticket
    let newChoosenTickets = choosenTickets.map((ticket) =>
      ticket.category === ticket_Category
        ? { ...ticket, quantity: ticket.quantity - 1, amount: (ticket.quantity - 1) * ticket.price }
        : ticket
    );


    // console.log({newChoosenTickets});

    // If the quantity of a ticket becomes 0, remove that ticket from the array
    newChoosenTickets = newChoosenTickets.filter(
      (ticket) => ticket.quantity > 0
    );

    // Calculate the total quantity of all tickets
    const newTotalTicketQty = newChoosenTickets.reduce(
      (acc, ticket) => acc + ticket.quantity,
      0
    );

    const newTotalTicketAmount = newChoosenTickets.reduce(
      (acc, ticket) => acc + ticket.quantity * ticket.price, 0
    )


    // Update the chosenTickets and totalTicketQty states
    setChoosenTickets(newChoosenTickets);
    setTotalTicketQty(newTotalTicketQty);
    setTotalTicketAmount(newTotalTicketAmount);
  }



  useEffect(()=>{
    console.log("totalAmount:",totalSeatQty + totalTicketQty)
    setTotalQty(totalSeatQty + totalTicketQty)
  }, [totalTicketQty, totalSeatQty])

  useEffect(()=>{
    setTotalAmount(totalSeatAmount + totalTicketAmount)
  },[totalTicketAmount, totalSeatAmount])

  function toggleSideBar() {
    sideBarRef.current.classList.toggle("view");
  }

  useEffect(() => {
    // Convert choosenTickets array to a string to store in localStorage

    // if(choosenTickets.length === 0 && seats === null) return
    const choosenTicketsString = JSON.stringify(choosenTickets);
    localStorage.setItem("choosenTickets", choosenTicketsString);

    const seatsString = JSON.stringify(seats);
    localStorage.setItem("seats", seatsString);
  }, [choosenTickets, seats]); // This effect runs whenever choosenTickets changes.


   function toEventBookingSummary(){


    if(choosenTickets.length === 0 && seats === null) return alert("Please select a ticket or a seat")

    const [eventName, eventVenue, eventDate, eventTime, evdt_Id] = selectedEvent

    const eventId = localStorage.getItem("id")
    const venueId = localStorage.getItem("venueId")
    localStorage.setItem("totalAmount", totalAmount)


    // const adultCountArr = choosenTickets.map(ct =>{
    //   return ct.quantity
    // })

    // const totalAdultCount = adultCountArr.reduce(addAdultCount)

    // function addAdultCount(total, num){
    //   return total + num
    // }


   
    // const seats = `[{"seatCategoryId":null,"seatNumbers":[],"adultCount":${totalAdultCount},"childCount":0}]`;
    

    // const encodedSeats = encodeURIComponent(seats);
    const endcodedEventName = encodeURIComponent(eventName);
    const encodedEventId = encodeURIComponent(eventId);
    const encodedVenueId = encodeURIComponent(venueId);
    const encodedShowId = encodeURIComponent(evdt_Id);
    const encodedShowDate = encodeURIComponent(eventDate);
    const encodedVenue = encodeURIComponent(eventVenue);
    const encodedShowTime = encodeURIComponent(eventTime);

    

    const url = `/eventbookingsummary?seats=${seats}&eventName=${endcodedEventName}&eventId=${encodedEventId}&venueId=${encodedVenueId}&showId=${encodedShowId}&showDate=${encodedShowDate}&venue=${encodedVenue}&showtime=${encodedShowTime}`
    navigate(url)

  }




  return (
    <>
      {/* <PrimarySearchAppBar /> */}

      {isTicketsData ? (
        <div className="wrapper">
          <div className="checkout-Wrapper ">
            <div className="selectedEventInfo flexB">
              <div className="selectedEvent_and_Venue">
                {selectedEvent ? (
                  <h2 className="eventName">
                    <b>{selectedEvent[0]}</b>
                  </h2>
                ) : (
                  <h2 className="eventName">Not Available</h2>
                )}
                {selectedEvent ? (
                  <p className="eventVenue">{selectedEvent[1]}</p>
                ) : (
                  <p className="eventVenue">Not Available</p>
                )}
              </div>

              <div className="selectedDate_and_Time flexB">
                {selectedEvent ? (
                  <p className="eventDate">{selectedEvent[2]}</p>
                ) : (
                  <p className="eventDate">Not Available</p>
                )}

                {selectedEvent ? (
                  <p className="eventTime">{selectedEvent[3]}</p>
                ) : (
                  <p className="eventTime">Not Available</p>
                )}

                <button className="sideBarBtn viewticketSelection" onClick={toggleSideBar}>
                  <span className="totalTicketQtyDisplay">
                    {totalQty} 
                  </span>{" "}
                  Tickets
                </button>
              </div>
            </div>
          </div>

          <div className={boxPlan ? "tickets" : "tickets flexB"}>
            {boxPlan ? (
              <p>Under Development</p>
            ) : tickets ? (
              tickets.map((ticket) => (
                <div className="ticket" key={ticket.et_id}>
                  <div className="ticket_Details">
                    <p className="category">{ticket.category}</p>
                    <p className="price">
                      <span className="currency">{ticket.currency + " "}</span>
                      <span className="amount">{convert(ticket.price)}</span>
                    </p>
                  </div>
                  {ticket.box_plan?
                  <div className="flexB justify-center"><button className="globalBtn"><a href={ticket.box_plan_url}>Box Plan </a></button></div>: 
                       <div className="selectTicketQuantity flexB">
                       <button
                      className="minus qtyBtn"
                      onClick={() => {
                        removeTicket(ticket.category);
                      }}
                    >
                      -
                    </button>
                    
                    <div className="quantity flexB">
                      {choosenTickets.find(
                        (choosenTickets) =>
                          choosenTickets.category === ticket.category
                      )?.quantity || 0}

                      <div>/{ticket.available}</div> 
                    </div>
                    <button
                      className="add qtyBtn"
                      onClick={() => {
                        addTickets(ticket.category, ticket.price, ticket.et_id, ticket.available);
                      }}
                    >
                      +
                    </button>
                  </div>   }
                </div>
              ))
            ) : (
              <p>Tickets Not Available</p>
            )}
          </div>

          <div className="sideBar flexB" ref={sideBarRef}>
            <div className="ticketCheckoutSummary">
              {choosenTickets.map((ticket) => (
                <div className="flexB ticketDetails_Price ">
                  <div className="ticketInfo flexB">
                    <div>{ticket.category}</div>
                    <div className="ticketQuantity-sidebar"><p>x{ticket.quantity}</p></div>
                  </div>
                  <div className="ticketAmount">
                    {convert(ticket.quantity * ticket.price)}
                  </div>
                </div>
              ))}
              {seats && seats.map((seat)=>(<>
                <div className="flexB ticketDetails_Price ">
                  <div className="ticketInfo flexB" >
                    <div>{seat.type}</div>
                    <div className="ticketQuantity-sidebar"><p>x{seat.adultCount}</p></div>
                    <div className="seatNumbers flexB" style={{gap: "8px"}}>{seat.seatNumbers && seat.seatNumbers.map((seatNo)=>(<div className="seatNo">{seatNo}</div>))}</div>
                  </div>
                  <div className="ticketAmount">
                    {convert(seat.amount)}
                  </div>
                </div>
              </>))}
            </div>
            
            
            <div className="amountPayable flexB">
              <p>Total</p>
              <div className="totalAmount">{convert(totalAmount)}</div>
            </div>

            <div className="buttonsForCheckout_and_AddMoreTickets">
             <div>
               <button to="/eventbookingsummary" className="checkoutBtn" onClick={toEventBookingSummary}>
                Checkout
              </button>
              <button className="addMoreTicketsBtn" onClick={toggleSideBar}>
                Add More +
              </button>
             </div>
            </div>
          </div>

          <div className="overlay" onClick={toggleSideBar}></div>
        </div>
      ) : (
        <Preloader />
      )}

    
    </>
  );
};

export default CheckOut;
